import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import useAdventureMusic from '../audio/useAdventureMusic';
import MusicAttentionBubble from './MusicAttentionBubble';

var HEADER_SLOT_ID = 'music-nav-slot';

function IconPlay() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <path fill="currentColor" d="M8 5.5v13l11-6.5L8 5.5z" />
    </svg>
  );
}

function IconPause() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <path fill="currentColor" d="M7 5h3.5v14H7V5zm6.5 0H17v14h-3.5V5z" />
    </svg>
  );
}

function IconSpeaker() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <path
        fill="currentColor"
        d="M4 9v6h3.2L12 19.5V4.5L7.2 9H4zm11.5 1.1a3.5 3.5 0 010 3.8l-1.2-1.1a1.9 1.9 0 000-1.6l1.2-1.1zm2.3-2.4a6.5 6.5 0 010 8.6l-1.2-1.2a4.8 4.8 0 000-6.2l1.2-1.2z"
      />
    </svg>
  );
}

function IconMuted() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <path
        fill="currentColor"
        d="M4 9v6h3.2L12 19.5V4.5L7.2 9H4zm12.7-.3l1.4 1.4 1.4-1.4 1.1 1.1-1.4 1.4 1.4 1.4-1.1 1.1-1.4-1.4-1.4 1.4-1.1-1.1 1.4-1.4-1.4-1.4 1.1-1.1z"
      />
    </svg>
  );
}

function IconMusicNote() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 3v11.35A3.5 3.5 0 1118 11V7.2l-8 1.8V16.35A3.5 3.5 0 118 13V5.7L20 3z"
      />
    </svg>
  );
}

function getHeaderSlot() {
  if (typeof document === 'undefined') return null;
  return document.getElementById(HEADER_SLOT_ID);
}

export default function AdventureMusicControls() {
  var music = useAdventureMusic();
  var _slot = useState(null);
  var headerSlot = _slot[0];
  var setHeaderSlot = _slot[1];

  useEffect(function () {
    setHeaderSlot(getHeaderSlot());
  }, []);

  if (music.reducedMotion) return null;

  var controls = (
    <div
      className="adventure-music adventure-music--header"
      role="group"
      aria-label="Adventure music"
    >
      <MusicAttentionBubble
        musicPlaying={music.playing}
        onPlayMusic={music.play}
      />
      <span className="adventure-music__mark" title="Music" aria-hidden="true">
        <IconMusicNote />
      </span>
      <button
        type="button"
        className="adventure-music__btn"
        onClick={music.togglePlay}
        aria-pressed={music.playing}
        aria-label={music.playing ? 'Pause music' : 'Play music'}
        title={music.playing ? 'Pause music' : 'Play music'}
      >
        {music.playing ? <IconPause /> : <IconPlay />}
      </button>
      <button
        type="button"
        className="adventure-music__btn"
        onClick={music.toggleMute}
        aria-pressed={music.muted}
        aria-label={music.muted ? 'Unmute music' : 'Mute music'}
        title={music.muted ? 'Unmute music' : 'Mute music'}
      >
        {music.muted ? <IconMuted /> : <IconSpeaker />}
      </button>
    </div>
  );

  if (!headerSlot) return null;
  return createPortal(controls, headerSlot);
}
